/**
 * Telugu (తెలుగు) translations
 */
import { TranslationStrings } from '../types';

export const te: TranslationStrings = {  common: {
    loading: 'లోడ్ అవుతోంది...',
    error: 'లోపం సంభవించింది',
    retry: 'మళ్ళీ ప్రయత్నించండి',
    cancel: 'రద్దు',
    confirm: 'నిర్ధారించు',
    back: 'వెనుకకు',
    next: 'తదుపరి',
    submit: 'సమర్పించు',
    done: 'పూర్తయింది',
    close: 'మూసివేయి',
    yes: 'అవును',
    no: 'కాదు',
    required: 'అవసరం',
    optional: 'ఐచ్ఛికం',
  },
  consent: {
    secureConsent: 'సురక్షిత సమ్మతి',
    yourConsentRequired: 'మీ సమ్మతి అవసరం',
    consentingAs: 'సమ్మతి ఇస్తున్నది',
    requestingOrg: 'అభ్యర్థిస్తున్న సంస్థ',
    dataBeingCollected: 'సేకరించబడుతున్న డేటా',
    purposeOfProcessing: 'ప్రాసెసింగ్ ఉద్దేశం',
    whatYouWillDo: 'మీరు ఏమి చేస్తారు',
    reviewDocuments: 'పత్రాలను సమీక్షించండి',
    provideConsent: 'సమ్మతి ఇవ్వండి',
    documentsToRead: 'చదవాల్సిన పత్రాలు',
    estimatedTime: 'అంచనా సమయం',
    minutes: 'నిమిషాలు',
    startReview: 'సమీక్ష ప్రారంభించండి',
    yourRights: 'DPDP చట్టం 2023 కింద మీ హక్కులు',
    rightToAccess: 'మీ డేటాను యాక్సెస్ చేసే హక్కు',
    rightToCorrect: 'మీ డేటాను సరిదిద్దే హక్కు',
    rightToWithdraw: 'సమ్మతిని ఉపసంహరించుకునే హక్కు',
    rightToGrievance: 'ఫిర్యాదులు దాఖలు చేసే హక్కు',
    stepOf: 'దశ {current} / {total}',
    pleaseReadCarefully: 'దయచేసి సమ్మతి ఇచ్చే ముందు ప్రతి పత్రాన్ని జాగ్రత్తగా చదవండి.',
    documentsReviewed: 'సమీక్షించిన పత్రాలు',
    remaining: 'మిగిలినవి',
    allDocumentsReviewed: 'అన్ని పత్రాలు సమీక్షించబడ్డాయి!',
    clickToRead: 'చదవడానికి ప్రతి పత్రంపై క్లిక్ చేయండి',
    proceedToConsent: 'మీరు సమ్మతి ఇవ్వడానికి కొనసాగవచ్చు',
    markAsRead: 'చదివినట్లు గుర్తించండి',
    continueReading: 'చదవడం కొనసాగించండి',
    confirmConsent: 'మీ సమ్మతిని నిర్ధారించండి',
    selectMethod: 'ధృవీకరణ పద్ధతిని ఎంచుకోండి',
    iAgreeToTerms: 'అన్ని నిబంధనలు, విధానాలు మరియు సమ్మతి ఒప్పందాలతో నేను అంగీకరిస్తున్నాను',
    readAllDocuments: 'నా సమ్మతి స్వచ్ఛందమైనది మరియు ఎప్పుడైనా ఉపసంహరించుకోవచ్చని నేను అర్థం చేసుకుంటున్నాను',
    submitConsent: 'సమ్మతి సమర్పించండి',
    submitting: 'సమర్పిస్తోంది...',
    digitalSignature: 'డిజిటల్ సంతకం',
    smsVerification: 'SMS ధృవీకరణ',
    emailVerification: 'ఇమెయిల్ ధృవీకరణ',
    videoRecording: 'వీడియో రికార్డింగ్',
    audioRecording: 'ఆడియో రికార్డింగ్',
    checkboxConfirmation: 'చెక్‌బాక్స్ నిర్ధారణ',
    drawSignature: 'మీ సంతకం వేయండి',
    verifyViaSms: 'SMS కోడ్ ద్వారా ధృవీకరించండి',
    verifyViaEmail: 'ఇమెయిల్ కోడ్ ద్వారా ధృవీకరించండి',
    recordVideoConsent: 'వీడియో సమ్మతి రికార్డ్ చేయండి',
    recordAudioConsent: 'ఆడియో సమ్మతి రికార్డ్ చేయండి',
    confirmByChecking: 'చెక్ చేసి నిర్ధారించండి',
    enterOtp: 'OTP నమోదు చేయండి',
    otpSentTo: 'OTP పంపబడింది',
    resendOtp: 'OTP మళ్ళీ పంపండి',
    verifyOtp: 'OTP ధృవీకరించండి',
    otpVerified: 'OTP ధృవీకరించబడింది',
    invalidOtp: 'చెల్లని OTP',
    startRecording: 'రికార్డింగ్ ప్రారంభించండి',
    stopRecording: 'రికార్డింగ్ ఆపండి',
    retake: 'మళ్ళీ తీయండి',
    recordingComplete: 'రికార్డింగ్ పూర్తయింది',
    consentSubmitted: 'సమ్మతి విజయవంతంగా సమర్పించబడింది',
    thankYou: 'సమ్మతి ఇచ్చినందుకు ధన్యవాదాలు',
    confirmationSent: 'మీ ఇమెయిల్‌కు నిర్ధారణ పంపబడింది',
    referenceNumber: 'సూచన సంఖ్య',
    errorSubmitting: 'సమ్మతి సమర్పించడంలో విఫలమైంది. దయచేసి మళ్ళీ ప్రయత్నించండి.',
    pleaseReadDocs: 'దయచేసి ముందుగా అన్ని పత్రాలు చదవండి',
    pleaseProvideEvidence: 'దయచేసి సమ్మతి సాక్ష్యం అందించండి',
  },
  documents: {
    privacyPolicy: 'గోప్యతా విధానం',
    termsOfService: 'సేవా నిబంధనలు',
    consentAgreement: 'సమ్మతి',
    dataSharingAgreement: 'డేటా భాగస్వామ్య ఒప్పందం',
    cookiePolicy: 'కుకీ విధానం',
    retentionPolicy: 'డేటా నిలుపుదల విధానం',
    gdprNotice: 'GDPR నోటీసు',
    hipaaAuthorization: 'HIPAA అధికారం',
    ccpaDisclosure: 'CCPA వెల్లడి',
    aadhaarAuthorization: 'ఆధార్ అధికారం',
    customDocument: 'అనుకూల పత్రం',
  },
  dataCategories: {
    personalInfo: 'వ్యక్తిగత సమాచారం',
    contactDetails: 'సంప్రదింపు వివరాలు',
    financialInfo: 'ఆర్థిక సమాచారం',
    healthData: 'ఆరోగ్య మరియు వైద్య డేటా',
    biometricData: 'బయోమెట్రిక్ డేటా',
    locationData: 'స్థాన డేటా',
    behavioralData: 'ప్రవర్తన డేటా',
    communicationData: 'కమ్యూనికేషన్ డేటా',
    employmentInfo: 'ఉపాధి సమాచారం',
    educationInfo: 'విద్యా సమాచారం',
  },
  a11y: {
    mainContent: 'ప్రధాన కంటెంట్',
    navigation: 'నావిగేషన్',
    closeModal: 'మోడల్ మూసివేయండి',
    expandSection: 'విభాగం విస్తరించండి',
    collapseSection: 'విభాగం కుదించండి',
    documentRead: 'పత్రం చదివినట్లు గుర్తించబడింది',
    documentUnread: 'పత్రం ఇంకా చదవలేదు',
    progressIndicator: 'పురోగతి: {current} / {total} పత్రాలు చదివారు',
    signaturePad: 'సంతకం ప్రాంతం',
    clearSignature: 'సంతకం తుడిచివేయండి',
    videoPlayer: 'వీడియో రికార్డింగ్ ప్లేయర్',
    audioPlayer: 'ఆడియో రికార్డింగ్ ప్లేయర్',
    requiredField: 'ఈ ఫీల్డ్ అవసరం',
    errorMessage: 'లోపం',
    successMessage: 'విజయం',
    loadingContent: 'కంటెంట్ లోడ్ అవుతోంది, దయచేసి వేచి ఉండండి',
    newWindow: 'కొత్త విండోలో తెరవబడుతుంది',
  },
  portal: {
    // General
    myConsents: 'నా సమ్మతులు',
    viewManageConsents: 'మీ సమ్మతి రికార్డులను చూడండి మరియు నిర్వహించండి',
    logout: 'లాగౌట్',
    welcomeBack: 'తిరిగి స్వాగతం',
    
    // Tenant selector
    organizationNameOrCode: 'సంస్థ పేరు లేదా కోడ్',
    orgPlaceholder: 'ఉదా., globalhealth లేదా acme-corp',
    orgHint: 'మీ సంస్థ అందించిన పేరు లేదా కోడ్ నమోదు చేయండి',
    findMyOrganization: 'నా సంస్థను కనుగొనండి',
    orgNotFound: 'సంస్థ కనుగొనబడలేదు. దయచేసి పేరు తనిఖీ చేసి మళ్ళీ ప్రయత్నించండి.',
    enterOrgName: 'దయచేసి మీ సంస్థ పేరు లేదా కోడ్ నమోదు చేయండి',
    or: 'లేదా',
    haveDirectLink: 'మీ సంస్థ నుండి నేరుగా లింక్ ఉందా?',
    useDirectLink: 'వారు అందించిన లింక్ ఉపయోగించండి',
    privacyProtected: 'మీ గోప్యత చట్టం ద్వారా రక్షించబడుతుంది',
    
    // Login flow
    phoneOrEmail: 'ఫోన్ నంబర్ లేదా ఇమెయిల్',
    enterPhoneOrEmailPlaceholder: 'మీ నమోదిత ఫోన్ లేదా ఇమెయిల్ నమోదు చేయండి',
    otpWillBeSent: 'మేము మీకు వన్-టైమ్ పాస్‌వర్డ్ (OTP) పంపుతాము',
    sendOtp: 'OTP పంపు',
    enterPhoneOrEmail: 'దయచేసి మీ ఫోన్ నంబర్ లేదా ఇమెయిల్ నమోదు చేయండి',
    otpSentTo: 'OTP పంపబడింది',
    expiresIn: 'గడువు ముగుస్తుంది',
    enterOtp: 'OTP నమోదు చేయండి',
    enterValidOtp: 'దయచేసి చెల్లుబాటు అయ్యే OTP నమోదు చేయండి',
    verifyOtp: 'OTP ధృవీకరించు',
    resendOtp: 'OTP మళ్ళీ పంపు',
    otpVerified: 'OTP ధృవీకరించబడింది',
    oneMoreStep: 'మీ గుర్తింపును ధృవీకరించడానికి మరో అడుగు',
    enterSecurityAnswer: 'దయచేసి మీ సమాధానం నమోదు చేయండి',
    enterAnswer: 'సమాధానం నమోదు చేయండి',
    dobFormat: 'ఫార్మాట్: DDMMYYYY (ఉదా., 15051990 మే 15, 1990)',
    login: 'లాగిన్',
    startOver: 'మళ్ళీ ప్రారంభించు',
    needHelp: 'సహాయం కావాలా?',
    privacyNotice: 'మీ డేటా వర్తించే గోప్యతా చట్టాల క్రింద రక్షించబడుతుంది',
    checkUrlOrContact: 'దయచేసి URL తనిఖీ చేయండి లేదా మీ సంస్థను సంప్రదించండి.',
    
    // Consent history
    filterAll: 'అన్నీ',
    statusActive: 'సక్రియం',
    statusWithdrawn: 'ఉపసంహరించబడింది',
    statusExpired: 'గడువు ముగిసింది',
    noConsents: 'సమ్మతి రికార్డులు కనుగొనబడలేదు',
    noConsentsWithFilter: 'ఈ స్థితిలో సమ్మతులు లేవు',
    consentedOn: 'సమ్మతి తేదీ',
    expiresOn: 'గడువు ముగిసే తేదీ',
    withdrawnOn: 'ఉపసంహరించిన తేదీ',
    withdrawConsent: 'సమ్మతి ఉపసంహరించు',
    withdrawalHistory: 'ఉపసంహరణ చరిత్ర',
    help: 'సహాయం',
    
    // Withdrawal
    cannotWithdraw: 'ఈ సమ్మతిని ఉపసంహరించలేము',
    pleaseConfirmWithdrawal: 'దయచేసి పరిణామాలను అర్థం చేసుకున్నారని నిర్ధారించండి',
    importantNotice: 'ముఖ్యమైన నోటీసు',
    withdrawalNotice1: 'పేర్కొన్న ప్రయోజనాల కోసం మీ డేటాను ప్రాసెస్ చేయడం సంస్థ ఆపివేస్తుంది.',
    withdrawalNotice2: 'చట్టపరమైన అనుసరణ కోసం కొంత డేటా నిలుపుకోవచ్చు.',
    withdrawalNotice3: 'కొన్ని సేవలను ఉపయోగించడానికి మీరు మళ్ళీ సమ్మతి అందించాల్సి రావచ్చు.',
    withdrawalNotice4: 'వర్తించే చట్టాల ప్రకారం ప్రాసెసింగ్ సమయం 7-30 రోజులు పట్టవచ్చు.',
    withdrawalReason: 'ఉపసంహరణకు కారణం',
    withdrawalReasonPlaceholder: 'మీరు ఎందుకు ఉపసంహరించాలనుకుంటున్నారో చెప్పండి (ఐచ్ఛికం)',
    withdrawalConfirmation: 'నా సమ్మతిని ఉపసంహరించడం కొన్ని సేవలను ఉపయోగించే నా సామర్థ్యాన్ని ప్రభావితం చేయవచ్చని నేను అర్థం చేసుకున్నాను, ఈ అభ్యర్థనతో కొనసాగాలనుకుంటున్నాను.',
    submitWithdrawalRequest: 'ఉపసంహరణ అభ్యర్థన సమర్పించు',
    withdrawalSubmitted: 'ఉపసంహరణ అభ్యర్థన సమర్పించబడింది',
    withdrawalSubmittedDesc: 'మీ ఉపసంహరణ అభ్యర్థన సమర్పించబడింది. సంస్థ ప్రాసెస్ చేసిన తర్వాత మీకు తెలియజేయబడుతుంది.',
    processingTime: 'ప్రాసెసింగ్ సమయం',
    days: 'రోజులు',
    backToHistory: 'సమ్మతి చరిత్రకు తిరిగి వెళ్ళు',
    
    // Withdrawal history
    statusPending: 'పెండింగ్',
    statusApproved: 'ఆమోదించబడింది',
    statusRejected: 'తిరస్కరించబడింది',
    noWithdrawals: 'ఉపసంహరణ అభ్యర్థనలు లేవు',
    viewConsents: 'మీ సమ్మతులు చూడండి',
    requestedOn: 'అభ్యర్థించిన తేదీ',
    processedOn: 'ప్రాసెస్ చేసిన తేదీ',
    processingMessage: 'మీ అభ్యర్థన ప్రాసెస్ అవుతోంది. పూర్తయిన తర్వాత మీకు తెలియజేయబడుతుంది.',
    processingTimeInfo: 'ప్రాసెసింగ్ సమయ సమాచారం',
    
    // Help section
    yourRights: 'మీ గోప్యతా హక్కులు',
    helpTitle: 'మీ గోప్యతా హక్కులను అర్థం చేసుకోండి',
    helpSubtitle: 'గోప్యతా చట్టాల క్రింద మీ హక్కులు మరియు సమ్మతిని ఎలా నిర్వహించాలో తెలుసుకోండి.',
    quickActions: 'త్వరిత చర్యలు',
    viewMyConsents: 'నా సమ్మతులు చూడు',
    viewWithdrawalRequests: 'ఉపసంహరణ అభ్యర్థనలు చూడు',
    loginToViewConsents: 'మీ సమ్మతులు చూడటానికి లాగిన్ అవ్వండి',
    applicableLaws: 'వర్తించే గోప్యతా చట్టాలు',
    
    // Rights FAQ
    rightAccessQ: 'యాక్సెస్ హక్కు అంటే ఏమిటి?',
    rightAccessA: 'మీ గురించి ఏ వ్యక్తిగత డేటా సేకరించబడుతోంది, అది ఎలా ఉపయోగించబడుతోంది, ఎవరితో షేర్ చేయబడుతోంది అని తెలుసుకునే హక్కు మీకు ఉంది.',
    rightCorrectQ: 'దిద్దుబాటు హక్కు అంటే ఏమిటి?',
    rightCorrectA: 'మీ వ్యక్తిగత డేటా తప్పుగా లేదా అసంపూర్ణంగా ఉంటే, దాన్ని సరిదిద్దమని లేదా నవీకరించమని అభ్యర్థించవచ్చు.',
    rightWithdrawQ: 'సమ్మతి ఉపసంహరించుకునే హక్కు అంటే ఏమిటి?',
    rightWithdrawA: 'మీరు ఎప్పుడైనా మీ సమ్మతిని ఉపసంహరించుకోవచ్చు. ఉపసంహరించిన తర్వాత, మీరు సమ్మతించిన ప్రయోజనాల కోసం మీ డేటాను ప్రాసెస్ చేయడం సంస్థ ఆపివేయాలి.',
    rightEraseQ: 'తొలగింపు హక్కు అంటే ఏమిటి?',
    rightEraseA: '"మరచిపోయే హక్కు" అని కూడా పిలవబడే, మీ వ్యక్తిగత డేటాను తొలగించమని అభ్యర్థించవచ్చు. అయితే, కొంత సమాచారాన్ని నిలుపుకోవడానికి చట్టపరమైన కారణాలు ఉండవచ్చు.',
    
    // Withdrawal FAQ
    withdrawalFaq: 'ఉపసంహరణ ప్రక్రియ',
    withdrawHowQ: 'నా సమ్మతిని ఎలా ఉపసంహరించాలి?',
    withdrawHowA: 'మీ ఖాతాలో లాగిన్ అవ్వండి, సమ్మతి చరిత్రకు వెళ్ళండి, సక్రియ సమ్మతిపై "సమ్మతి ఉపసంహరించు" క్లిక్ చేయండి.',
    withdrawTimeQ: 'ఉపసంహరణకు ఎంత సమయం పడుతుంది?',
    withdrawTimeA: 'వర్తించే చట్టాల ప్రకారం ప్రాసెసింగ్ సమయాలు: DPDP చట్టం (భారతదేశం) - 7 రోజులు, GDPR (EU) - 30 రోజులు, CCPA (కాలిఫోర్నియా) - 45 రోజులు.',
    withdrawEffectQ: 'సమ్మతి ఉపసంహరించిన తర్వాత ఏమి జరుగుతుంది?',
    withdrawEffectA: 'పేర్కొన్న ప్రయోజనాల కోసం మీ డేటాను ఉపయోగించడం సంస్థ ఆపివేస్తుంది. చట్టపరమైన అనుసరణ కోసం కొంత డేటా నిలుపుకోవచ్చు.',
    
    // Security FAQ
    securityFaq: 'ఖాతా భద్రత',
    loginSecureQ: 'నా లాగిన్ ఎలా సురక్షితం?',
    loginSecureA: 'మేము 3-స్టెప్ ధృవీకరణ ప్రక్రియను ఉపయోగిస్తాము: నమోదిత ఫోన్/ఇమెయిల్‌కు OTP, తర్వాత భద్రతా ప్రశ్న.',
    dataProtectQ: 'నా డేటా ఎలా రక్షించబడుతుంది?',
    dataProtectA: 'అన్ని డేటా రవాణాలో మరియు విశ్రాంతిలో ఎన్‌క్రిప్ట్ చేయబడుతుంది. DPDP చట్టం, GDPR మరియు ఇతర గోప్యతా నియమాలను అనుసరిస్తాము.',
    
    // Contact FAQ
    contactFaq: 'సంప్రదింపు & మద్దతు',
    grievanceQ: 'ఫిర్యాదు ఎలా దాఖలు చేయాలి?',
    grievanceA: 'సంస్థ డేటా ప్రొటెక్షన్ ఆఫీసర్ (DPO) లేదా ఫిర్యాదుల అధికారిని సంప్రదించవచ్చు.',
    regulatorQ: 'నియంత్రణ అధికారి ఎవరు?',
    regulatorA: 'భారతదేశంలో, డేటా ప్రొటెక్షన్ బోర్డ్ గోప్యతా ఫిర్యాదులను నిర్వహిస్తుంది. EU లో, మీ జాతీయ డేటా ప్రొటెక్షన్ అథారిటీని సంప్రదించవచ్చు.',
  },
}
;
